import { gsap } from 'gsap';

export default class Registration {
    constructor(el, app) {
        this.el = el;
        this.app = app;
        this.html = document.documentElement;

        this.cacheDom();
        this.init();
    }

    /* -----------------------------------------
     * DOM
     * ----------------------------------------- */
    cacheDom() {
        this.dom = {
            html: document.documentElement,
            form: document.getElementById('form-register'),
            password: document.getElementById('password'),
            confirmPassword: document.getElementById('confirmPassword'),
            formError: document.querySelector('.js-form-error'),
        };
    }

    /* -----------------------------------------
     * Init
     * ----------------------------------------- */
    init() {
        // Match confirmed password
        this.dom.confirmPassword.addEventListener('input', () => {
            if (this.dom.password.value !== this.dom.confirmPassword.value) {
                this.dom.confirmPassword.setCustomValidity('Passwords do not match.');
            } else {
                this.dom.confirmPassword.setCustomValidity('');
            }
        });

        // 8 characters for password
        this.dom.form.addEventListener('submit', (event) => {
            if (this.dom.password.value.length < 8) {
                event.preventDefault();
                gsap.to(this.dom.formError, {
                    opacity: 1,
                    display: 'block',
                });
            }
        });
    }
}
